module.exports = __webpack_public_path__ + "static/media/4379.295cc7dc.jpg";